import { request as __request } from '../core/request';

export class SaveTestersConsentService {
  public static async SaveTestersConsent({
        missionId,
    }: {
        missionId: string | null,
    }): Promise<any> {
    const result = await __request({
        method: "POST",
        path: `/api/mission/testerConsent`,
        query: {
            'missionId': missionId,
        },
    });
    return result.body;
  }
}